import { UserFromApi } from '@sdk/users/types/UserFromApi';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { PersonaCollection } from '@sdk/personaCollection/types/PersonaCollection';
import { ConversationPersonaFromApi } from '@sdk/messages/types/apiTypes';
import { User } from '@sdk/users/types/User';
import { Persona } from '@sdk/personaCollection/types/Persona';
import { ObjectWithId } from '@sdk/common/types/ObjectWithId';

import { getPersonaFromAPI } from '@web/common/utils/getPersonaFromAPI';

export const getNewsfeedUser = (
  user: UserFromApi | ObjectWithId,
  personaCollection: PersonaCollection,
  currentUser: AuthUserType
): User => getPersonaFromAPI(user, personaCollection, currentUser);

export const getNewsfeedPersona = (
  user: ConversationPersonaFromApi | ObjectWithId,
  personaCollection: PersonaCollection,
  currentUser: AuthUserType
): Persona => getPersonaFromAPI(user, personaCollection, currentUser);
